import { render, staticRenderFns } from "./order-delivery.vue?vue&type=template&id=391372b8&scoped=true"
import script from "./order-delivery.vue?vue&type=script&lang=js"
export * from "./order-delivery.vue?vue&type=script&lang=js"
import style0 from "./order-delivery.vue?vue&type=style&index=0&id=391372b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391372b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391372b8')) {
      api.createRecord('391372b8', component.options)
    } else {
      api.reload('391372b8', component.options)
    }
    module.hot.accept("./order-delivery.vue?vue&type=template&id=391372b8&scoped=true", function () {
      api.rerender('391372b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Order/order-delivery.vue"
export default component.exports